var axios = require('axios'),
    qs = require('qs'),
    filter = require('./utils')

var createApi = function (url, params, option) {
    if (option) {
      option.timeout = 10000
    } else {
      option = { timeout: 10000 }
    }
    return new Promise(function(resolve, reject) {
    axios.post(url, qs.stringify(filter(params)), option)
    .then(function(response) {
      const res = response.data
      if (!res) {
        reject({ message: '请求结果为空' })
      } else if (typeof res !== 'object') {
        reject({ message: '服务端返回异常' })
      } else if (res.ret === -1) {
        res.message = res.msg
        reject(res)
      } else {
        resolve(res) // request success
      }
    })
    .catch(function(error) {
      reject({ message: '网络请求失败' })
    })
  })
}

module.exports = createApi



//////////////////
// WEBPACK FOOTER
// ./~/ci-network/network/index.js
// module id = 164
// module chunks = 3